import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            valor: 0,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.presupuesto.coeficientesue.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El Coeficiente ha sido creada con éxito."}
                title={"Nuevo Coeficiente UE"}
                buttonTitle={"Nuevo Coeficiente UE"}
                buttonIcon={"fa fa-plus fa-lg"}
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del coeficiente</p>
                        <ParadigmaLabeledInput autoFocus fieldName="nombre" label="Nombre" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput
                            onChange={(e) => this.setState({ valor: e.target.value })}
                            value={this.state.valor} type={"number"} fieldName="valor" label="Valor" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput type={"textarea"} fieldName="descripcion" label="Descripción" labelColumns={12} fieldColumns={12} />
                    </section>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_CoeficientesUE/Create.js